<template>
  <div class="news" ref="news-container">
    <div v-for="newsItem in newsItems" v-bind:key="newsItem.title" class="news__item">
      <img :src="newsItem.imageUrl" alt="News image" class="news__item__image">
      <h2 class="news__item__title">{{ newsItem.title }}</h2>
      <p class="news__item__summary" v-html="newsItem.summary" />
      <a :href="newsItem.url" target="_blank" class="news__item__url button">{{ t('Lire plus') }}</a>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Confirmation',
  data () {
    return ({
      newsItems: []
    })
  },
  mounted () {
    this.loadNews()
  },
  methods: {
    loadNews () {
      axios
        .get(`${this.$store.state.domain}/api/fr/news`).then(response => {
        if (response.status === 200) {
          this.newsItems = response.data

          const element = this.$refs['news-container'];
          const top = element.offsetTop;
          window.scrollTo(0, top)
        }
      })
    },
    onCopy () {
      const confirmationInput = document.getElementById('code-de-confirmation')
      if (confirmationInput) {
        confirmationInput.focus()
        navigator.clipboard.writeText(confirmationInput.value)
        this.toggleCopyMessage()
      }
    },
    toggleCopyMessage () {
      this.isCopied = true
      setTimeout(() => {
        this.isCopied = false
      }, 1000)
    },
    editAppointment () {
      this.invalidConfirmationCode = false
      this.isConfirmationCodeChecked = true

      this.numberValidated = true

      this.$store.commit('changeData', {
        type: 'summarySection',
        value: false
      })

      this.$store.commit('changeData', {
        type: 'confirmation',
        value: false
      })

      this.$store.commit('changeData', {
        type: 'isExistingAppointment',
        value: true
      })

      this.$store.commit('changeData', {
        type: 'sivecNumberConfirmation',
        value: true
      })

      this.$store.commit('changeData', {
        type: 'dateSelection',
        value: true
      })
    }
  }
}

</script>

<style scoped lang="scss">
@import "src/assets/scss/button";

.news {
  padding: 3.5em 1rem 1rem;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: -50vw;
    bottom: 0;
    left: -50vw;
    background-color: white;
  }
}

.news__item {
  position: relative;
  background-color: var(--green--light);
  border-radius: 15px 15px 60px 15px;;
  max-width: 680px;
  margin: 0 auto 70px;
  padding: 15px;
  padding-left: 150px;

  @media only screen and (max-width: 850px) {
    padding-left: 110px;
  }

  @media only screen and (max-width: 500px) {
    padding-top: 80px;
    padding-left: 15px;
    margin: 0 auto 100px;
  }
}

.news__item__title {
  color: var(--green--dark);
  font-size: 36px;
  font-family: montserrat, sans-serif;
  font-weight: 800;
  font-style: normal;
  margin: 10px 0 15px 0;
}

.news__item__summary {
  color: var(--green--dark);
}

.news__item__url {
  display: inline-block;
}

.news__item__image {
  position: absolute;
  width: 180px;
  height: 180px;
  object-fit: cover;
  border-radius: 200px;
  left: -50px;
  top: -50px;

  @media only screen and (max-width: 850px) {
    top: -25px;
    left: -25px;
    height: 120px;
    width: 120px;
  }

  @media only screen and (max-width: 500px) {
    top: -60px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
